import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./i18n/config";
import "./index.css";
import { applyStatusBarHeight, fixIOSWebViewHeight } from "./lib/utils";

// Apply status bar height on app start
applyStatusBarHeight();

// Fix iOS WebView height issue
fixIOSWebViewHeight();

// Register Service Worker for WASM caching
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        console.log("[SW] Service Worker registered:", registration.scope);
        
        // Check for updates periodically
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000); // Check every hour
      })
      .catch((error) => {
        console.warn("[SW] Service Worker registration failed:", error);
      });
  });
}

// Delay Sentry initialization (non-critical)
setTimeout(() => {
  import("@sentry/react").then((Sentry) => {
    Sentry.init({
      dsn: "https://2bf577dda3a7e22d022de7f5287958a3@sentry.corp.very.org/9",
      // enabled: process.env.NODE_ENV !== "development",
    });
  });
}, 0);

createRoot(document.getElementById("root")!).render(<App />);
